/**
 * Tipos centrais dos métodos de pagamento.
 *
 * Cada método tem seu próprio sub-componente cerimonial (PIX, Cartão, Pontos,
 * Milhas, Cripto) e devolve ao orquestrador um `PaymentConfirmPayload` com
 * `detailsFake` curto, humano-legível, pra histórico privado da `Registration`.
 *
 * O método é PRIVADO — nunca aparece em telas públicas (certificado, PDF,
 * /c/:id, mosaico).
 */

export type PaymentMethod = 'pix' | 'card' | 'points' | 'miles' | 'crypto';

export type PaymentConfirmPayload = {
  method: PaymentMethod;
  /** Texto curto mostrado em telas privadas (ex.: "VISA ****4242", "0.005 ETH"). */
  detailsFake?: string;
};

export const PAYMENT_METHOD_LABEL: Record<PaymentMethod, string> = {
  pix: 'PIX',
  card: 'Cartão',
  points: 'Pontos',
  miles: 'Milhas',
  crypto: 'Cripto',
};

export const PAYMENT_METHOD_ORDER: PaymentMethod[] = [
  'pix',
  'card',
  'points',
  'miles',
  'crypto',
];
